<template>
  <div class="adm-content-item" v-if="value">
    <div class="adm-content-item__title">
      <slot name="checkbox"></slot>
      <h5 style="color:#3C3C3C" :title="`舆情编号：${value.id}`">{{ !!value.title ? value.title : "" }}</h5>
      <small class="adm-content-item__type" title="在新窗口打开" v-if="!!value.url">
        <a :href="value.url" target="__brank" rel="noopener noreferrer">
          <iv-icon type="md-open" size="16" style="vertical-align:text-bottom" />
        </a>
      </small>
      <span v-if="value.sentimentType==0" style="font-weight:normal;mergin-left:50px">（发布时间：{{ value.postTime | timesify }}）</span>
      <span v-if="value.sentimentType==1" style="font-weight:normal;mergin-left:50px">（爬取时间：{{ value.postTime | timesify }}）</span>
      <a
        :href="previewUrl"
        target="EventsPreviewWindow"
        @click="onOriginClick">
        <span>详情>></span>
      </a>
    </div>
    <div class="adm-content-item__detail">
      <div class="adm-content-item__meta">
        <div>
          公司名称：<span class="t-s">{{ value.companyInfo.abbreviation }} </span>
        </div>
        <div>
          数据来源：<span class="t-s">{{ value.source }}</span>
        </div>
        <div>
          二级指标：<span class="t-s">{{ value.secondTargetName }}</span>
        </div>
        <div>
          三级指标：<span class="t-s">{{ value.thirdTargetName }}</span>
        </div>
      </div>
      <div class="adm-content-item__meta">
        <div>
          类型：<span class="t-s">{{ ['舆情','处罚'][value.sentimentType] }}</span>
        </div>
        <div>
          <span>评分：<span class="t-s" style="font-size:18px;">{{ value.score }}</span></span>
        </div>
        <div>
          <span>总得分：<span class="t-s" style="font-size:18px;">{{ value.weightedScore }}</span></span>
        </div>
        <div class="adm-flex-group ui-wrap" style="margin-left:-10px;margin-right:-10px;">
          <div
            v-for="dimension in value.dimensionInfo"
            :key="dimension.dimensionId"
            style="padding:0 10px">
            <div style="width:150px">
              {{ dimension.dimension }}({{ dimension.dimensionScore }})<br />
              <iv-progress :percent=" (dimension.dimensionScore / dimension.dimensionWeight) * 100" hide-info :stroke-width="6" />
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.adm-content-item {
  font-size: 12px;
  padding: 15px 12px;
  color: #999999;
  &__title {
    font-size: 12px;
    margin-bottom: 0.5em;
    h5{
      display: inline;
      font-size: 14px;
    }
    small {
      color: #aaa;
      font-weight: normal;
      margin-left: 0.625em;
    }
    .item_edit {
      color: #2d8cf0;
      &:hover {
        cursor: pointer;
      }
    }
  }
  &__detail {
    display: flex;
    justify-content: space-between;
    margin: 0 -15px;
    > *{
      padding: 0 15px;
    }
  }
  &__meta {
    flex-grow: 1;
    flex-shrink: 1;
    position: relative;
    &::after {
      content: "";
      width: 1px;
      border-right: 1px solid #dddddd;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
    }
    > div {
      line-height: 22px;
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    .negative > .ivu-select >>> .ivu-select-selection {
      background: #ed4c4c;
    }
    .positive > .ivu-select >>> .ivu-select-selection {
      background: #33ab15;
    }
    .item_section {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //作为弹性伸缩盒子模型显示。
      -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
      -webkit-line-clamp: 3; //显示的行
    }
  }

  &__content {
    display: flex;
    justify-content: space-between;
  }
  &__buttons {
    opacity: 1;
    transition: opacity 0.5s ease-out;
    a,
    button {
      margin-left: 0.625em;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  &__type {
    // vertical-align: middle;
    margin-left: 7px;
  }
  &__read {
    color: #2d8cf0;
  }
  &__exclude {
    color: #ed4c4c;
  }
  &__not {
    color: #666;
  }
  .t-s {
    color: #666;
  }
  .t-a {
    color: #2d8cf0;
    text-decoration: underline;
  }
  .meta-01{
    display: block;
    @media screen and (max-width:1366px) {
      display: none;
    }
  }
  &__tip{
    display: none;
    margin-bottom: 1em;
    > span{
      margin-right:10px;
    }
    @media screen and (max-width:1366px) {
      display: block;
    }
  }

  .adm-content-item__meta {
    &:nth-child(1) {
      flex-grow: 0;
    }
    &:last-child{
      &::after {
        display: none;
      }
    }
  }
}
</style>
<script>
export default {
  props: {
    value: Object,
  },
  data() {
    let routerJump = this.$router.resolve({ name:'storage_preview', params:{ storageName:'EVENTS_PREVIEW' } })
    return {
      previewUrl: routerJump.href,
    }
  },
  methods: {
    onOriginClick(){
      $emit('preview', this.value)
    },
  }
};
</script>
